import config from "./config.js";

const API_BASE = config.serverUrl ? config.serverUrl : "http://localhost:4025/api";

export default API_BASE;
